/**
 * 게임 상태 컨테이너 (data-model §6, 헌법 "단일 게임 상태 객체 + 이벤트 에미터").
 * 세부 상태는 각 시스템(Session/Score/Spawner)이 소유하고, GameState는 이를 묶어
 * 파생 질의(상호작용 가능 여부, 전체 파괴 여부)와 스냅샷을 제공한다.
 */
import type { Session } from '../gameplay/Session';
import type { ScoreSystem } from '../gameplay/ScoreSystem';
import type { ObjectSpawner } from '../gameplay/ObjectSpawner';
import type { SessionPhase } from './types';

export interface StateSnapshot {
  phase: SessionPhase;
  score: number;
  combo: number;
  maxCombo: number;
  intactObjects: number;
}

export class GameState {
  constructor(
    public readonly session: Session,
    public readonly score: ScoreSystem,
    public readonly spawner: ObjectSpawner,
  ) {}

  /** 플레이 중이면 상호작용 가능(던지기 제한 없음 — 다 부수면 종료). */
  get canInteract(): boolean {
    return this.session.isPlaying;
  }

  /** 책상 위 부술 물건을 모두 부쉈는가(종료 조건). */
  get allBroken(): boolean {
    return this.session.isPlaying && this.spawner.intactCount === 0;
  }

  snapshot(): StateSnapshot {
    return {
      phase: this.session.phase,
      score: this.score.state.score,
      combo: this.score.state.combo,
      maxCombo: this.score.state.maxCombo,
      intactObjects: this.spawner.intactCount,
    };
  }
}
